import { z } from "zod";
import { AgencyIdSchema } from "../../primitives/ids.js";
import { DeliveryProjectIdSchema } from "./entities.js";
import { getWebsiteDeliveryVerticalContract } from "./vertical-contract.js";
export const WebsiteDeliveryEstimateV1Schema = z
    .object({
    schemaVersion: z.literal("clientops.website-delivery-estimate.v1.0"),
    estimateId: z.string().regex(/^wdest_[a-zA-Z0-9_-]+$/),
    estimateVersion: z.number().int().positive(),
    agencyId: AgencyIdSchema,
    deliveryProjectId: DeliveryProjectIdSchema,
    verticalContractVersion: z.string().min(1),
    lineItems: z.array(z
        .object({
        ruleId: z.string().min(1),
        quantity: z.number().positive(),
        amountCents: z.number().int().nonnegative(),
    })
        .strict()),
    subtotalCents: z.number().int().nonnegative(),
    currency: z.literal("USD"),
    assumptions: z.array(z.string().min(1)).min(1),
    status: z.enum(["DRAFT", "ISSUED", "SUPERSEDED"]),
    createdAt: z.string().datetime(),
})
    .strict();
export function buildWebsiteDeliveryEstimate(input) {
    const contract = getWebsiteDeliveryVerticalContract();
    const pageRate = contract.rates.find((r) => r.ruleId === "rate_page_standard");
    if (!pageRate) {
        throw new Error("missing_rate_page_standard");
    }
    const amountCents = Math.round(input.pageCount * pageRate.amountCents);
    return WebsiteDeliveryEstimateV1Schema.parse({
        schemaVersion: "clientops.website-delivery-estimate.v1.0",
        estimateId: input.estimateId,
        estimateVersion: input.estimateVersion,
        agencyId: input.agencyId,
        deliveryProjectId: input.deliveryProjectId,
        verticalContractVersion: contract.contractVersion,
        lineItems: [
            {
                ruleId: pageRate.ruleId,
                quantity: input.pageCount,
                amountCents,
            },
        ],
        subtotalCents: amountCents,
        currency: "USD",
        assumptions: input.assumptions,
        status: "DRAFT",
        createdAt: input.now ?? new Date().toISOString(),
    });
}
//# sourceMappingURL=estimate.js.map